import { render, staticRenderFns } from "./banner.edit.vue?vue&type=template&id=3618a932&scoped=true"
import script from "./banner.edit.vue?vue&type=script&lang=js"
export * from "./banner.edit.vue?vue&type=script&lang=js"
import style0 from "./banner.edit.vue?vue&type=style&index=0&id=3618a932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618a932",
  null
  
)

export default component.exports